import { Cartesian2 } from "cesium";

interface Vec2 {
    x: number;
    y: number;
}

export function getDistanceToLine2D(linePoint1: Cartesian2 | Vec2, linePoint2: Cartesian2 | Vec2, distantPoint: Cartesian2 | Vec2) {
    const A = linePoint2.y - linePoint1.y,
        B = linePoint2.x - linePoint1.x;

    return Math.abs(A * (linePoint1.x - distantPoint.x) + B * (distantPoint.y - linePoint1.y)) / Math.sqrt(A * A + B * B);
}
